/**
 * Invoice Exchange Rate Source
 *
 * Provenance of the exchange rate stored on an invoice.
 */
export const DocumentExchangeRateSource = {
  EXTRACTION: 'EXTRACTION', // Read off the document (AI extraction or ISDOC)
  EXTERNAL: 'EXTERNAL', // Fetched from an external rate provider (CNB/ECB)
  MANUAL: 'MANUAL' // Entered manually by the user
} as const;

export type DocumentExchangeRateSource =
  (typeof DocumentExchangeRateSource)[keyof typeof DocumentExchangeRateSource];
